import { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AppBar } from "./components/AppBar";
import { LockOverlay } from "./components/LockOverlay";
import { Toast } from "./components/Toast";
import { useIdleLock } from "./hooks/useIdleLock";
import { useToastStore } from "./store/toast";
import { useAuthStore } from "./store/auth";
import { DEMO_MODE } from "./lib/config";
import { SessionPage } from "./pages/SessionPage";
import { SessionsListPage } from "./pages/SessionsListPage";
import { PatientsPage } from "./pages/PatientsPage";
import { PatientNewPage } from "./pages/PatientNewPage";
import { SessionNewPage } from "./pages/SessionNewPage";
import { ReportsPage } from "./pages/ReportsPage";
import { AuditPage } from "./pages/AuditPage";
import { SettingsPage } from "./pages/SettingsPage";
import { LoginPage } from "./pages/LoginPage";

export default function App() {
  const status = useAuthStore((s) => s.status);
  const user = useAuthStore((s) => s.user);
  const { locked, secondsRemaining, unlock } = useIdleLock();
  const toast = useToastStore((s) => s.current);
  const location = useLocation();

  useEffect(() => {
    document.title = "Financing Copilot";
  }, []);

  // Demo mode bypasses the auth gate. Production must require login.
  const requireAuth = !DEMO_MODE;

  if (requireAuth && status !== "ready") {
    return <div className="empty">Loading…</div>;
  }

  if (requireAuth && !user && location.pathname !== "/login") {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (requireAuth && user && location.pathname === "/login") {
    return <Navigate to="/sessions" replace />;
  }

  return (
    <div className="app">
      {(!requireAuth || user) && <AppBar idleSecondsRemaining={secondsRemaining} />}
      <Routes>
        <Route path="/" element={<Navigate to="/sessions" replace />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/sessions" element={<SessionsListPage />} />
        <Route path="/sessions/new" element={<SessionNewPage />} />
        <Route path="/sessions/:id" element={<SessionPage />} />
        <Route path="/patients" element={<PatientsPage />} />
        <Route path="/patients/new" element={<PatientNewPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/audit" element={<AuditPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<div className="empty">Not found</div>} />
      </Routes>
      {locked && requireAuth && <LockOverlay onUnlock={unlock} />}
      <Toast toast={toast} />
    </div>
  );
}
